import { render, staticRenderFns } from "./ProductLockCutoff.vue?vue&type=template&id=be561c2a"
import script from "./ProductLockCutoff.vue?vue&type=script&lang=js"
export * from "./ProductLockCutoff.vue?vue&type=script&lang=js"
import style0 from "./ProductLockCutoff.vue?vue&type=style&index=0&id=be561c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports